import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-container dashboard-page-container" }
const _hoisted_2 = { class: "page-header page-header-with-tabs" }
const _hoisted_3 = { class: "w-full flex flex-wrap gap-3 justify-content-between" }
const _hoisted_4 = { class: "inline-flex gap-2" }
const _hoisted_5 = { class: "page-content" }

import { computed, onMounted, onBeforeUnmount, watch } from 'vue';
import MultiSelect from 'primevue/multiselect';
import TreeSelect from 'primevue/treeselect';
import { Activity, Overview, Payment, TimeUsage } from './components';
import AppTabMenu from '@/components/AppTabMenu';
import {
  useAttendanceStore,
  useAuthStore,
  useCustomerSuccessPartnerStore,
  useEvaluationStore,
  useOrganizationStore,
} from '@/store';
import { PERMISSIONS, TENANT_SETTINGS } from '@/enum';
import { useRouting, useTenant, can, usePersonTypes, useRequestCancel } from '@/composables';


export default /*@__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

const authStore = useAuthStore();
const organizationStore = useOrganizationStore();
const requestCancel = useRequestCancel();
const evaluationStore = useEvaluationStore();
const attendanceStore = useAttendanceStore();
const customerSuccessPartnerStore = useCustomerSuccessPartnerStore();
// Disabling Compliance widget for ticket TMS-1997
// const complianceStore = useComplianceStore();
const $tenant = useTenant();
const $routing = useRouting();

const organizationsIdsSelected = computed(() => organizationStore.organizationsIdsSelected);

const isSuperAdmin = usePersonTypes.isSuperAdmin();
const canViewUtilizationWidgets =
  can([PERMISSIONS.CLINICIAN_ANALYTICS]) &&
  (isSuperAdmin || usePersonTypes.isSupportAdmin() || usePersonTypes.isBillingAdmin());

const menuItems = computed(() => {
  const items = [
    {
      route: 'overview',
      label: 'Overview',
      component: Overview,
      disabled: () => $routing.route.path === '/dashboard/overview',
    },
  ];

  if (can([PERMISSIONS.DASHBOARD_ACTIVITY_INDEX])) {
    items.push({
      route: 'activity',
      label: 'Activity',
      component: Activity,
      disabled: () => $routing.route.path === '/dashboard/activity',
    });
  }

  if (can([PERMISSIONS.PAYMENT_ME])) {
    items.push({
      route: 'payment',
      label: 'Payment',
      component: Payment,
      disabled: () => $routing.route.path === '/dashboard/payment',
    });
  }

  if ($tenant.tenantSettingEnabled(TENANT_SETTINGS.UTILIZATION_TRACKING) && can([PERMISSIONS.PAYMENT_ME])) {
    items.push({
      route: 'time-usage',
      label: 'Time Usage',
      component: TimeUsage,
      disabled: () => $routing.route.path === '/dashboard/time-usage',
    });
  }

  return items;
});

onMounted(() => init());

const init = async () => {
  await authStore.getOrganizations();

  if (organizationStore.organizationsIdsSelected.length > 0) {
    await onOrganization();
  }
};

onBeforeUnmount(() => {
  requestCancel.requestSaverAbortAll();
});

watch(
  () => authStore.impersonateToken,
  (value, oldValue) => {
    if (oldValue) {
      init();
    }
  },
);

const onOrganization = async () => {
  evaluationStore.getEvaluations(organizationsIdsSelected.value);
  attendanceStore.getAllAttendance(organizationsIdsSelected.value);

  // Disabling Compliance widget for ticket TMS-1997
  // complianceStore.getAllCompliance(undefined, organizationsIdsSelected.value);
};

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "pb-2" }, "Dashboard", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(AppTabMenu), { items: menuItems.value }, null, 8, ["items"]),
        _createElementVNode("div", _hoisted_4, [
          (_unref($tenant).tenantSettingEnabled(_unref(TENANT_SETTINGS).UTILIZATION_TRACKING) && _unref(canViewUtilizationWidgets))
            ? (_openBlock(), _createBlock(_unref(MultiSelect), {
                key: 0,
                id: "organization_profile_general_customer_success_partner_id",
                modelValue: _unref(customerSuccessPartnerStore).selectedDashboardCustomerSuccessPartners,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(customerSuccessPartnerStore).selectedDashboardCustomerSuccessPartners) = $event)),
                options: _unref(customerSuccessPartnerStore).customerSuccessPartners,
                "option-label": "display_name",
                "max-selected-labels": 2,
                loading: _unref(customerSuccessPartnerStore).loading,
                placeholder: "All CSPs"
              }, null, 8, ["modelValue", "options", "loading"]))
            : _createCommentVNode("", true),
          (_unref(can)([_unref(PERMISSIONS).USERS_ORGANIZATIONS_SHOW]) && _unref(authStore).organizationAssociated.length)
            ? (_openBlock(), _createBlock(_unref(TreeSelect), {
                key: 1,
                id: "parent_organization",
                modelValue: _unref(organizationStore).selectedOrganizations,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(organizationStore).selectedOrganizations) = $event)),
                options: _unref(authStore).organizationAssociated,
                "option-label": "name",
                "option-value": "id",
                loading: _unref(authStore).loading,
                placeholder: "All Organizations",
                style: {"min-width":"240px"},
                class: "border-transparent max-w-sm font-bold",
                "scroll-height": "200px",
                "selection-mode": "multiple",
                display: "chip",
                "meta-key-selection": false,
                onChange: onOrganization
              }, null, 8, ["modelValue", "options", "loading"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_RouterView)
    ])
  ]))
}
}

})